import useJwt from '@/auth/jwt/useJwt'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

//var tokenJWT =  localStorage.getItem('accessToken')
//axiosIns.defaults.headers.common['Authorization'] = "`Bearer ${ tokenJWT }`"

const responseHandler = response => {

    if(response.headers?.authorization){
       const newToken = response.headers.authorization.split(' ')[1]
       useJwt.setToken(newToken)
    }

    return response;
};

const isLocalApiRequest = config => {
   if (!config?.url) return false

   try {
      const requestUrl = new URL(axiosIns.getUri(config), window.location.href)
      return requestUrl.origin === window.location.origin && requestUrl.pathname.startsWith('/api/')
   } catch (error) {
      return false
   }
}

const errorHandler = error => {
   if (error.response?.status === 401) {
      if(error.config?.url?.includes("www.migros")){
         if(error.response.data?.['leshop-error'] == 'expiredtoken'){
            localStorage.removeItem('tokenMigros')
         }
      }

      if(error.response.data && error.response.data.message == 'Not valid payment status!'){
         window.location.href = error.response.data.url;
      } else if (error.response.data?.message === 'Not valid id!' && isLocalApiRequest(error.config)) {
         localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
         localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
         localStorage.removeItem('userData')
         window.location.assign('/login')
      }
    }

    return Promise.reject(error);
};

axiosIns.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
 );

export default axiosIns
